import { getBezierPath } from "@xyflow/react";
import { RiArrowRightSFill } from "react-icons/ri";

const CustomConnectionLine = ({ fromX, fromY, toX, toY }) => {
    const [edgePath] = getBezierPath({
        sourceX: fromX,
        sourceY: fromY,
        targetX: toX,
        targetY: toY,
    });

    return (
        <g>
            <defs>
                <marker
                    id="arrow"
                    viewBox="0 0 10 10"
                    refX="5"
                    refY="5"
                    markerWidth="10"
                    markerHeight="10"
                    orient="auto"
                >
                    <circle
                        cx="5"
                        cy="5"
                        r="3"
                        fill="var(--originalBlack)"
                    />
                </marker>
            </defs>

            <path
                fill="none"
                stroke="var(--originalBlack)"
                strokeWidth={3}
                d={edgePath}
                markerEnd="url(#arrow)"
            />
        </g>
    );
};

export default CustomConnectionLine